export const MOVABLE_INK_INTEGRATIONS_URL = '/integrations/movableInk/get';
export const MOVABLE_INK_INTEGRATIONS_CREATE_URL = '/integrations/movableInk/add';
export const MOVABLE_INK_INTEGRATIONS_DELETE_URL = '/integrations/movableInk/delete';
export const MOVABLE_INK_GET_CAMPAIGNS = '/integrations/movableInk/getCampaigns';
export const MOVABLE_INK_GET_BLOCKS = '/integrations/movableInk/getBlocks';
export const MOVABLE_INK_GET_CHILD_INTEGRATIONS = '/integrations/movableInk/getAccounts';
